import { logger } from '@/core/utils/logger';

export interface FrontendErrorReportContext {
  module?: string;
  action?: string;
  stage?: string;
  status?: number;
  method?: string;
  url?: string;
  path?: string;
  apiMessage?: string;
  innerError?: unknown;
  /** When true, escalate to logger.error; otherwise breadcrumbs stay at warn/debug. */
  escalate?: boolean;
  [key: string]: unknown;
}

const buildError = (message: string, error?: Error): Error => {
  if (error) {
    return error;
  }

  return new Error(message);
};

export const reportFrontendError = (message: string, error?: Error, context: FrontendErrorReportContext = {}): void => {
  if (context.escalate !== true) {
    return;
  }

  const { escalate: _escalate, ...logContext } = context;
  logger.error(message, buildError(message, error), {
    service: 'front-backoffice',
    handled: true,
    ...logContext,
  });
};

export const addFrontendBreadcrumb = (message: string, context: FrontendErrorReportContext = {}): void => {
  const { escalate: _escalate, ...logContext } = context;
  const isErrorLevel = typeof context.status === 'number' && context.status >= 500;

  if (isErrorLevel) {
    logger.warn(message, {
      service: 'front-backoffice',
      breadcrumb: true,
      ...logContext,
    });
    return;
  }

  logger.debug(message, {
    service: 'front-backoffice',
    breadcrumb: true,
    ...logContext,
  });
};
